import {
  Box,
  IconButton,
  ListItemButton,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { markNotificationRead } from '../../modules/notification';
import { Circle } from '@mui/icons-material';
import { getTimeElapsed } from '../../lib/notificationUtils';

const NotificationItem = ({ notification, fetchNotifications }) => {
  const navigate = useNavigate();

  const handleNavigation = async (event) => {
    event.stopPropagation();
    if (notification.entity_link) {
      try {
        if (notification.status === 'unread') {
          await markNotificationRead(notification.id);
          await fetchNotifications();
        }
        navigate(notification.entity_link);
      } catch (error) {
        console.error('Error marking notification as read:', error);
      }
    }
  };

  return (
    <Box sx={{borderBottom: '1px solid #ddd'}}>
      <ListItemButton
        onClick={(e) => handleNavigation(e)}
        sx={{
          px: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          ...(notification.status === 'unread' && {
            bgcolor: 'action.hover',
            fontWeight: 'bold',
          }),
        }}>
        <ListItemText>
          <Typography
            variant="body2"
            sx={{ fontWeight: 'medium', textTransform: 'none' }}>
            {notification.title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.5, textTransform: 'none' }}>
            {notification.body}
            <Typography
              variant="caption"
              color="text.disabled"
              sx={{ display: 'block', mt: 0.5 }}>
              {getTimeElapsed(notification.created_at)}
            </Typography>
          </Typography>
        </ListItemText>

        {notification.status === 'unread' && (
          <Tooltip title="Mark as read" arrow>
            <IconButton onClick={handleNavigation} size="small">
              <Circle color="primary" sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        )}
      </ListItemButton>
    </Box>
  );
};

export default NotificationItem;
